import * as React from "react";
import Card from "@mui/material/Card";
import { Typography } from "@mui/material";
import { ASSETS } from "../../utils/config";
import { Stack, Box, IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { usePostMediaBrowserData } from "../../services/mutations";
import { useState } from "react";
import SearchBar from "./SearchBar";
import ImageMasonry from "./ImageMasonry";
import { useEffect } from "react";
import PageSection from "./PageSection";
import { makeStyles } from "@mui/styles";
import VideosMasonry from "./VideoMasonry";
import { useRef } from "react";

const useStyles = makeStyles((theme) => ({
  tabImage: {
    height: "12px",
    width: "auto",
    maxWidth: "24px",
    objectFit: "contain",
  },
  tabs: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "6px",
    marginTop: "8px",
    marginBottom: "8px",
  },
  tabItem: {
    minHeight: "28px",
    padding: "4px 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    backgroundColor: "#F6F7F9",
    border: "0.5px solid #E1E1E1",
    borderRadius: "4px",
    cursor: "pointer",
    fontFamily: "DM Sans",
    "&:focus-visible": {
      outline: "2px solid #9B5AF8",
      outlineOffset: "1px",
    },
  },
  tabLabel: {
    fontSize: "12px",
    fontFamily: "DM Sans",
    fontWeight: 500,
    color: "#123051",
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
  searchFor: {
    fontSize: "10px",
    fontFamily: "DM Sans",
    lineHeight: "20px",
    fontWeight: "500",
    marginBottom: "10px",
    whiteSpace: "nowrap", // Ensures the text stays in a single line
    overflow: "hidden", // Hides any overflow that doesn't fit in the box
    textOverflow: "ellipsis", // Adds an ellipsis (...) at the end of the truncated text
    maxWidth: "40ch",
  },
  emptyText: {
    fontSize: "10px",
    fontFamily: "DM Sans",
    lineHeight: "12px",
    fontWeight: "400",
    marginBottom: "10px",
    textAlign: "center",
    color: "#123051",
  },
  errorText: {
    fontSize: "12px",
    fontFamily: "DM Sans",
    lineHeight: "16px",
    fontWeight: "500",
    textAlign: "center",
    color: "#D14343",
  },
  retryButton: {
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 600,
    color: "#FFFFFF",
    backgroundColor: "#9B5AF8",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
    "&:focus-visible": {
      outline: "2px solid #123051",
      outlineOffset: "1px",
    },
  },
}));

export const mediaType = {
  images: 1,
  videos: 2,
};

const VideoSource = {
  pixels: 2,
  youtube: 1,
  bing: 3,
};

const ImageSource = {
  pixels: 2,
  bing: 1,
  google: 3,
};

export default function MediaBrowser({
  onCloseIconPress = () => {},
  editorRef,
}) {
  const [mainCategory, setmainCategory] = useState(mediaType.images);
  const [showNothing, setShowNothing] = useState(true);

  const [selectedVideoSource, setselectedVideoSource] = useState(
    VideoSource.youtube
  );
  const [selectedImageSource, setselectedImageSource] = useState(
    ImageSource.bing
  );

  const { mutate, isLoading, isError, data } = usePostMediaBrowserData();

  const [searchedText, setSearchedText] = useState("");
  const [pexelsImages, setPexelsImages] = useState([]);
  const [pexelsVideos, setPexelsVideos] = useState([]);
  const [bingImages, setBingImages] = useState([]);
  const [youtubeVideos, setYoutubeVideos] = useState([]);
  const [googleImages, setGoogleImages] = useState([]);
  const [bingVideos, setBingVideos] = useState([]);

  const previousSearchedText = useRef("");

  const [imageCache, setImageCache] = useState({});
  const [videoCache, setVideoCache] = useState({});

  const [imagePagination, setimagePagination] = useState({
    pixels: 1,
    bing: 1,
    google: 1,
  });

  const [videoPagination, setvideoPagination] = useState({
    pixels: 1,
    youtube: 1,
    bing: 1,
  });

  const [activeTab, setActiveTab] = useState(
    mainCategory === mediaType.videos ? VideoSource.youtube : ImageSource.google
  );

  const handleNextImage = () => {
    setimagePagination((prev) => ({
      ...prev,
      [selectedImageSource === ImageSource.pixels
        ? "pixels"
        : selectedImageSource === ImageSource.bing
        ? "bing"
        : "google"]:
        prev[
          selectedImageSource === ImageSource.pixels
            ? "pixels"
            : selectedImageSource === ImageSource.bing
            ? "bing"
            : "google"
        ] + 1,
    }));
  };

  const handlePreviousImage = () => {
    setimagePagination((prev) => ({
      ...prev,
      [selectedImageSource === ImageSource.pixels
        ? "pixels"
        : selectedImageSource === ImageSource.bing
        ? "bing"
        : "google"]: Math.max(
        0,
        prev[
          selectedImageSource === ImageSource.pixels
            ? "pixels"
            : selectedImageSource === ImageSource.bing
            ? "bing"
            : "google"
        ] - 1
      ),
    }));
  };

  const handleNextVideo = () => {
    setvideoPagination((prev) => ({
      ...prev,
      [selectedVideoSource === VideoSource.pixels
        ? "pixels"
        : selectedVideoSource === VideoSource.youtube
        ? "youtube"
        : "bing"]:
        prev[
          selectedVideoSource === VideoSource.pixels
            ? "pixels"
            : selectedVideoSource === VideoSource.youtube
            ? "youtube"
            : "bing"
        ] + 1,
    }));
  };

  const handlePreviousVideo = () => {
    setvideoPagination((prev) => ({
      ...prev,
      [selectedVideoSource === VideoSource.pixels
        ? "pixels"
        : selectedVideoSource === VideoSource.youtube
        ? "youtube"
        : "bing"]: Math.max(
        0,
        prev[
          selectedVideoSource === VideoSource.pixels
            ? "pixels"
            : selectedVideoSource === VideoSource.youtube
            ? "youtube"
            : "bing"
        ] - 1
      ),
    }));
  };

  const onNextPress = () => {
    if (mainCategory === mediaType.images) {
      handleNextImage();
    } else {
      handleNextVideo();
    }
  };

  const onPrevPress = () => {
    if (mainCategory === mediaType.images) {
      handlePreviousImage();
    } else {
      handlePreviousVideo();
    }
  };

  const getPageNumber = () => {
    if (mainCategory === mediaType.images) {
      if (selectedImageSource === ImageSource.bing) {
        return imagePagination.bing;
      } else if (selectedImageSource === ImageSource.google)
        return imagePagination.google;
      else {
        return imagePagination.pixels;
      }
    } else {
      if (selectedVideoSource === VideoSource.youtube) {
        return videoPagination.youtube;
      } else if (selectedVideoSource === VideoSource.bing)
        return videoPagination.bing;
      else {
        return videoPagination.pixels;
      }
    }
  };

  useEffect(() => {
    if (searchedText) {
      if (mainCategory === mediaType.images) {
        if (selectedImageSource === ImageSource.pixels) {
          fetchPexelImages();
        } else if (selectedImageSource === ImageSource.bing) {
          fetchBingImages();
        } else if (selectedImageSource === ImageSource.google) {
          fetchGoogleImages();
        }
      }
    }
  }, [imagePagination]);

  useEffect(() => {
    if (searchedText) {
      if (mainCategory === mediaType.videos) {
        if (selectedVideoSource === VideoSource.pixels) {
          fetchPixelVideos();
        } else if (selectedVideoSource === VideoSource.youtube) {
          fetchYoutubeVideos();
        } else if (selectedVideoSource === VideoSource.bing) {
          fetchBingVideos();
        }
      }
    }
  }, [videoPagination]);

  useEffect(() => {
    const pageNumber = getPageNumber();
    if (mainCategory === mediaType.images) {
      if (selectedImageSource === ImageSource.pixels) {
        setPexelsImages(data?.data);
        setImageCache((prev) => ({
          ...prev,
          [`pexels-${pageNumber}`]: data?.data,
        }));
      } else if (selectedImageSource === ImageSource.bing) {
        setBingImages(data?.data);
        setImageCache((prev) => ({
          ...prev,
          [`bing-${pageNumber}`]: data?.data,
        }));
      } else if (selectedImageSource === ImageSource.google) {
        setGoogleImages(data?.data);
        setImageCache((prev) => ({
          ...prev,
          [`google-${pageNumber}`]: data?.data,
        }));
      }
    } else {
      if (selectedVideoSource === VideoSource.pixels) {
        setPexelsVideos(data?.data);
        setVideoCache((prev) => ({
          ...prev,
          [`pixels-${pageNumber}`]: data?.data,
        }));
      } else if (selectedVideoSource === VideoSource.youtube) {
        setYoutubeVideos(data?.data);
        setVideoCache((prev) => ({
          ...prev,
          [`youtube-${pageNumber}`]: data?.data,
        }));
      } else if (selectedVideoSource === VideoSource.bing) {
        setBingVideos(data?.data);
        setVideoCache((prev) => ({
          ...prev,
          [`bing-${pageNumber}`]: data?.data,
        }));
      }
    }
  }, [data?.data]);

  const fetchGoogleImages = () => {
    if (!searchedText.trimEnd()) {
      return;
    }
    const pageNumber = getPageNumber();
    if (imageCache[`google-${pageNumber}`]) {
      setGoogleImages(imageCache[`google-${pageNumber}`]);
      return;
    }

    const requestData = {
      text: searchedText,
      type: mediaType.images,
      source: ImageSource.google,
      page: getPageNumber(),
      per_page: 20,
    };
    mutate(requestData);
  };

  const fetchPexelImages = () => {
    if (!searchedText.trimEnd()) {
      return;
    }
    const pageNumber = getPageNumber();
    if (imageCache[`pexels-${pageNumber}`]) {
      setPexelsImages(imageCache[`pexels-${pageNumber}`]);
      return;
    }

    const requestData = {
      text: searchedText,
      type: mediaType.images,
      source: ImageSource.pixels,
      page: getPageNumber(),
      per_page: 20,
    };
    mutate(requestData);
  };

  const fetchBingImages = () => {
    if (!searchedText.trimEnd()) {
      return;
    }

    const pageNumber = getPageNumber();
    if (imageCache[`bing-${pageNumber}`]) {
      setBingImages(imageCache[`bing-${pageNumber}`]);
      return;
    }
    const requestData = {
      text: searchedText,
      type: mediaType.images,
      source: ImageSource.bing,
      page: getPageNumber(),
      per_page: 20,
    };
    mutate(requestData);
  };

  const fetchPixelVideos = () => {
    if (!searchedText.trimEnd()) {
      return;
    }

    const pageNumber = getPageNumber();
    if (videoCache[`pixels-${pageNumber}`]) {
      setPexelsVideos(videoCache[`pixels-${pageNumber}`]);
      return;
    }
    const requestData = {
      text: searchedText,
      type: mediaType.videos,
      source: VideoSource.pixels,
      page: getPageNumber(),
      per_page: 8,
    };

    mutate(requestData);
  };

  const fetchYoutubeVideos = () => {
    if (!searchedText.trimEnd()) {
      return;
    }

    const pageNumber = getPageNumber();
    if (videoCache[`youtube-${pageNumber}`]) {
      setYoutubeVideos(videoCache[`youtube-${pageNumber}`]);
      return;
    }
    const requestData = {
      text: searchedText,
      type: mediaType.videos,
      source: VideoSource.youtube,
      page: getPageNumber(),
      per_page: 8,
    };

    mutate(requestData);
  };

  const fetchBingVideos = () => {
    if (!searchedText.trimEnd()) {
      return;
    }

    const pageNumber = getPageNumber();
    if (videoCache[`bing-${pageNumber}`]) {
      setBingVideos(videoCache[`bing-${pageNumber}`]);
      return;
    }

    const requestData = {
      text: searchedText,
      type: mediaType.videos,
      source: VideoSource.bing,
      page: getPageNumber(),
      per_page: 8,
    };

    mutate(requestData);
  };

  useEffect(() => {
    handleSearch();
  }, [mainCategory, selectedImageSource, selectedVideoSource]);

  const handleSearch = () => {
    if (previousSearchedText.current !== searchedText) {
      // Reset pagination and cache if the search text has changed
      setimagePagination({ pixels: 1, bing: 1, google: 1 });
      setvideoPagination({ pixels: 1, youtube: 1, bing: 1 });
      setPexelsImages([]);
      setBingImages([]);
      setGoogleImages([]);
      setImageCache({});
      setVideoCache({});
      previousSearchedText.current = searchedText;
    }

    if (mainCategory === mediaType.images) {
      if (selectedImageSource === ImageSource.pixels) {
        fetchPexelImages(); // fetch images from Pexels
      } else if (selectedImageSource === ImageSource.bing) {
        fetchBingImages(); // fetch images from Bing
      } else if (selectedImageSource === ImageSource.google) {
        fetchGoogleImages(); // fetch images from Google
      }
    } else {
      if (selectedVideoSource === VideoSource.pixels) {
        fetchPixelVideos(); // fetch videos from Pexels
      } else if (selectedVideoSource === VideoSource.youtube) {
        fetchYoutubeVideos(); // fetch videos from YouTube
      } else if (selectedVideoSource === VideoSource.bing) {
        fetchBingVideos(); // fetch videos from Bing
      }
    }
  };

  const handleTabClick = (tab) => {
    mainCategory === mediaType.videos
      ? setselectedVideoSource(tab)
      : setselectedImageSource(tab);
    setActiveTab(tab);
  };

  const renderTab = (tab, label, image) => (
    <Box
      key={tab}
      component="button"
      type="button"
      className={classes.tabItem}
      onClick={() => handleTabClick(tab)}
      aria-pressed={activeTab === tab}
      aria-label={label}
      style={{
        border:
          activeTab === tab ? "1px solid #123051" : "0.5px solid #E1E1E1",
      }}
    >
      <img src={image} alt="" aria-hidden="true" className={classes.tabImage} />
      <span className={classes.tabLabel}>{label}</span>
    </Box>
  );

  const diablePrevious = getPageNumber() === 1;

  const classes = useStyles();
  const videosDataLength =
    mainCategory === mediaType.videos
      ? selectedVideoSource === VideoSource.pixels
        ? pexelsVideos?.length
        : selectedVideoSource === VideoSource.youtube
        ? youtubeVideos?.length
        : selectedVideoSource === VideoSource.bing
        ? bingVideos?.length
        : 0
      : 0;

  const imagesDataLength =
    mainCategory === mediaType.images
      ? selectedImageSource === ImageSource.pixels
        ? pexelsImages?.length
        : selectedImageSource === ImageSource.bing
        ? bingImages?.length
        : selectedImageSource === ImageSource.google
        ? googleImages?.length
        : 0
      : 0;

  const showPages =
    (mainCategory === mediaType.videos &&
      ((selectedVideoSource === VideoSource.pixels &&
        pexelsVideos?.length > 0) ||
        (selectedVideoSource === VideoSource.youtube &&
          youtubeVideos?.length > 0) ||
        (selectedVideoSource === VideoSource.bing &&
          bingVideos?.length > 0))) ||
    (mainCategory === mediaType.images &&
      ((selectedImageSource === ImageSource.pixels &&
        pexelsImages?.length > 0) ||
        (selectedImageSource === ImageSource.bing && bingImages?.length > 0) ||
        (selectedImageSource === ImageSource.google &&
          googleImages?.length > 0)));

  return (
    <Card
      sx={{
        width: "20vw",
        height: "100%",
        borderRadius: 5,
        marginX: 0,
        padding: 2,
      }}
    >
      <Stack direction={"row-reverse"}>
        <IconButton
          onClick={onCloseIconPress}
          aria-label="Close media browser"
          size="small"
          sx={{ p: 0.5 }}
        >
          <CloseSharpIcon fontSize="small" />
        </IconButton>
      </Stack>
      <div style={{ padding: 10, marginTop: 10 }}>
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "DM Sans",
            lineHeight: "20px",
            fontWeight: "500",
            marginBottom: "10px",
          }}
          variant="subtitle"
          color="text.primary"
        >
          Media Browser
        </Typography>
      </div>
      <SearchBar
        value={searchedText}
        onSearchIconPress={handleSearch}
        onSelect={(e) => setmainCategory(e)}
        onEnterPress={handleSearch}
        onChange={(e) => {
          if (previousSearchedText !== "" && e === "") {
            pexelsImages?.length > 0 && setPexelsImages([]);
            bingImages?.length > 0 && setBingImages([]);
            googleImages?.length > 0 && setGoogleImages([]);
            pexelsVideos?.length > 0 && setPexelsVideos([]);
            youtubeVideos?.length > 0 && setYoutubeVideos([]);
            bingVideos?.length > 0 && setBingVideos([]);
          }
          setSearchedText(e);
        }}
      ></SearchBar>
      <Box className={classes.tabs}>
        {mainCategory === mediaType.videos
          ? [
              renderTab(VideoSource.youtube, "YouTube", ASSETS.youtubeicon),
              renderTab(VideoSource.bing, "Bing", ASSETS.Bing),
              renderTab(VideoSource.pixels, "Pexels", ASSETS.Pexels),
            ]
          : [
              renderTab(ImageSource.google, "Google", ASSETS.google),
              renderTab(ImageSource.bing, "Bing", ASSETS.Bing),
              renderTab(ImageSource.pixels, "Pexels", ASSETS.Pexels),
            ]}
      </Box>
      {searchedText.length && data?.data?.length ? (
        <Typography variant="h6" className={classes.searchFor}>
          Searched for "{searchedText}"
        </Typography>
      ) : null}
      {searchedText === "" ? (
        <Box
          sx={{
            height: "54vh",
            paddingLeft: "34px",
            paddingRight: "34px",
            marginTop: "20px",
          }}
        >
          <Typography variant="h6" className={classes.emptyText}>
            Select type and enter keyword to search the desired media
          </Typography>
        </Box>
      ) : isError ? (
        <Box
          sx={{
            height: "54vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingLeft: "34px",
            paddingRight: "34px",
          }}
          role="alert"
        >
          <Typography variant="h6" className={classes.errorText}>
            Couldn't load media right now. Please check your connection and try
            again.
          </Typography>
          <Box
            component="button"
            type="button"
            onClick={handleSearch}
            className={classes.retryButton}
          >
            Try again
          </Box>
        </Box>
      ) : mainCategory === mediaType.videos ? (
        <VideosMasonry
          showData={videosDataLength}
          isLoading={isLoading}
          videos={
            selectedVideoSource === VideoSource.pixels
              ? pexelsVideos
              : selectedVideoSource === VideoSource.youtube
              ? youtubeVideos
              : selectedVideoSource === VideoSource.bing
              ? bingVideos
              : []
          }
          editorRef={editorRef}
        />
      ) : (
        <ImageMasonry
          showData={imagesDataLength}
          isLoading={isLoading}
          images={
            selectedImageSource === ImageSource.pixels
              ? pexelsImages
              : selectedImageSource === ImageSource.bing
              ? bingImages
              : selectedImageSource === ImageSource.google
              ? googleImages
              : []
          }
        />
      )}
      {!showPages ? null : (
        <PageSection
          diablePrevious={diablePrevious}
          onNextPress={onNextPress}
          onPrevPress={onPrevPress}
        />
      )}
    </Card>
  );
}
